<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  ERROR
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_60 lgo_02'><dynamic-field [id]='"messageline"' [size]=60 [(ngModel)]='messageline'></dynamic-field></div>
</div>
</div>
